import { render, staticRenderFns } from "./ModifyView.vue?vue&type=template&id=3ce4d05a&"
import script from "./ModifyView.vue?vue&type=script&lang=ts&"
export * from "./ModifyView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports